import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/modules/auth/actions";
import { userSelector } from "../../redux/modules/auth/userSelector";

export function NavbarToggler({ hideUser = false }: { hideUser?: boolean }) {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const user = useSelector(userSelector);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const showUser = !hideUser && user && user.role === "user";

  return (
    <div className="d-flex align-items-center" style={{ gap: showUser ? "8px" : "0" }}>
      {showUser && (
        <div className="d-flex align-items-center">
          <span
            className="text-muted small mr-3"
            style={{ fontWeight: 500 }}
          >
            {user.firstName}
          </span>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleLogout}
            title="Logout"
          >
            <i className="fa fa-sign-out mr-1"></i>
            Logout
          </button>
        </div>
      )}
      <div className="toggler">
        <button
          className="btn nav-btn navbar-toggler d-block d-lg-none"
          type="button"
          onClick={() => {
            const navBar = document.querySelector(".vertical-nav");
            navBar?.classList.toggle("menuIn");
          }}
        >
          <span className="fa fa-bars"></span>
        </button>
      </div>
    </div>
  );
}
